// Phosphor icons for the whole portal, one weight everywhere.
// The Icon* names match the Tabler names pages already used, so swapping a page over is a one line import change.
import { createElement, forwardRef } from 'react';
import {
  ArrowClockwise,
  ArrowLeft,
  ArrowsCounterClockwise,
  ArrowsLeftRight,
  ArrowSquareOut,
  Broadcast,
  Camera,
  CaretLeft,
  CaretRight,
  CaretUpDown,
  ChartBar,
  Check,
  ClockCounterClockwise,
  CloudArrowUp,
  Copy,
  Cube,
  Cards,
  DeviceRotate,
  Diamond,
  DotsThree,
  DownloadSimple,
  Eye,
  EyeSlash,
  Gear,
  GlobeHemisphereEast,
  GridFour,
  MagnifyingGlass,
  MapPin,
  Package,
  PencilSimple,
  Play,
  Plus,
  ShoppingCart,
  SignOut,
  SlidersHorizontal,
  SquaresFour,
  X,
} from '@phosphor-icons/react';

export const ICON_WEIGHT = 'regular';

function compat(Icon, name) {
  const Wrapped = forwardRef(function PortalIcon({ size = 24, stroke, color = 'currentColor', weight, ...rest }, ref) {
    void stroke;
    return createElement(Icon, {
      ref,
      size,
      color,
      weight: weight || ICON_WEIGHT,
      'aria-hidden': rest['aria-label'] ? undefined : true,
      ...rest,
    });
  });
  Wrapped.displayName = name;
  return Wrapped;
}

export const IconAdjustmentsHorizontal = compat(SlidersHorizontal, 'IconAdjustmentsHorizontal');
export const IconArrowLeft = compat(ArrowLeft, 'IconArrowLeft');
export const IconArrowsExchange = compat(ArrowsLeftRight, 'IconArrowsExchange');
export const IconBrandTwitch = compat(Broadcast, 'IconBrandTwitch');
export const IconCamera = compat(Camera, 'IconCamera');
export const IconCards = compat(Cards, 'IconCards');
export const IconChartBar = compat(ChartBar, 'IconChartBar');
export const IconCheck = compat(Check, 'IconCheck');
export const IconChevronLeft = compat(CaretLeft, 'IconChevronLeft');
export const IconChevronRight = compat(CaretRight, 'IconChevronRight');
export const IconCloudUpload = compat(CloudArrowUp, 'IconCloudUpload');
export const IconCopy = compat(Copy, 'IconCopy');
export const IconCube = compat(Cube, 'IconCube');
export const IconDeviceMobileRotated = compat(DeviceRotate, 'IconDeviceMobileRotated');
export const IconDiamond = compat(Diamond, 'IconDiamond');
export const IconDots = compat(DotsThree, 'IconDots');
export const IconDownload = compat(DownloadSimple, 'IconDownload');
export const IconExternalLink = compat(ArrowSquareOut, 'IconExternalLink');
export const IconEye = compat(Eye, 'IconEye');
export const IconEyeOff = compat(EyeSlash, 'IconEyeOff');
export const IconHistory = compat(ClockCounterClockwise, 'IconHistory');
export const IconLayoutDashboard = compat(SquaresFour, 'IconLayoutDashboard');
export const IconLayoutGrid = compat(GridFour, 'IconLayoutGrid');
export const IconLogout = compat(SignOut, 'IconLogout');
export const IconMapPin = compat(MapPin, 'IconMapPin');
export const IconPackage = compat(Package, 'IconPackage');
export const IconPencil = compat(PencilSimple, 'IconPencil');
export const IconPlayerPlay = compat(Play, 'IconPlayerPlay');
export const IconPlus = compat(Plus, 'IconPlus');
export const IconRefresh = compat(ArrowClockwise, 'IconRefresh');
export const IconRotate = compat(ArrowsCounterClockwise, 'IconRotate');
export const IconSearch = compat(MagnifyingGlass, 'IconSearch');
export const IconSelector = compat(CaretUpDown, 'IconSelector');
export const IconSettings = compat(Gear, 'IconSettings');
export const IconShoppingCart = compat(ShoppingCart, 'IconShoppingCart');
export const IconTorii = compat(GlobeHemisphereEast, 'IconTorii');
export const IconX = compat(X, 'IconX');
